(function() {
    const $removeBtn = $('.js-tag-remove'),
          $popupBtn = $('.js-popup'),
          $overlay  = $('.overlay');
    
    $popupBtn.on('click', function() {
        const $targetOverly = $(this).attr('data-popup-name');
        $('.overlay[overlay-name = "' +  $targetOverly + '"]').show();
    });

    $removeBtn.on('click', function() {
        $overlay.hide();
    });
})();